module.exports = __webpack_public_path__ + "assets/Retina-Medium.5312598cfead0122ab250e1a7bb4b1b1.woff";